import { gql } from "@apollo/client";

export default gql`
  query Route($id: Int!) {
    route(id: $id) {
      id
      name
      active
      points {
        id
        address {
          city
          complement
          country
          id
          latitude
          longitude
          neighborhood
          name
          number
          postalCode
          reference
          state
          street
        }
        position
        routeType
      }
    }
  }
`;
